module.exports = __webpack_public_path__ + "assets/escudo.2525095f.svg";